import { useState, useEffect } from 'react'
import { api } from '../api/client.js'

export function useAuditLogResourceTypes() {
  const [resourceTypes, setResourceTypes] = useState<string[]>([])
  const [loading, setLoading] = useState(true)
  const [error, setError] = useState<string | null>(null)

  useEffect(() => {
    async function fetchResourceTypes() {
      try {
        setLoading(true)
        const response = await api.get<{ resourceTypes: string[] }>('/admin/compliance/audit-log/resource-types')
        setResourceTypes(response.resourceTypes)
        setError(null)
      } catch (err) {
        setError(err instanceof Error ? err.message : 'Failed to fetch resource types')
      } finally {
        setLoading(false)
      }
    }

    void fetchResourceTypes()
  }, [])

  return { resourceTypes, loading, error }
}
